import useQuestionBankContext from '../../../../../../api/QuestionBankContext';
import SelectElement from '../../../../../../components/forms/SelectElement';
import type { Question } from '../../../../../../data/interface-question';
import type { QuestionBankID } from '../../../../../../data/interface-question-bank';
import type { OptionObjMustHaves } from '../../../../../../data/interface-utils';

interface FilterByCategoryProps {
	categoryID: string;
	// issuesFilter: boolean;
	// enurmSelect: string;
	// categorySelect: string;
	filterByCategory: (v: string) => void;
	questionBankID: QuestionBankID;
	questions: Question[];
}

const FilterByCategory = ({
	categoryID,
	// issuesFilter,
	// enurmSelect,
	// categorySelect,
	filterByCategory,
	questionBankID,
	questions
}: FilterByCategoryProps) => {
	const { categories } = useQuestionBankContext();

	// if (categories === undefined) return null;
	// return (
	// <div>
	// {/* {issuesFilter === false && enurmSelect === 'default' && ( */}
	// <div className='col 12'>
	// <select
	// className='browser-default'
	// id='category'
	// name='category'
	// // defaultValue={categorySelect}
	// onChange={filterByCategory}
	// tabIndex={1}
	// required>
	// <option value='default' disabled>
	// -- Category --
	// </option>
	// <option value='all'>Show All</option>
	// {categories
	// .filter((c) => c.questionBank === questionBankID)
	// .map((option) => {
	// return (
	// <option
	// value={`${option.name}`}
	// key={`${option.id}`}>{`${option.name}`}</option>
	// );
	// })}
	// </select>
	// </div>
	// {/* )} */}
	// </div>
	// );

	const loadCategories = (): OptionObjMustHaves[] => {
		const cats: OptionObjMustHaves[] = [
			{
				id: 'all',
				value: `All Categories (${questions.length})`
			}
		];
		categories
			?.filter((c) => c.questionBank === questionBankID)
			.map((cat) => {
				const count = questions.filter(
					(question) => question.categoryID === cat.id
				).length;
				return cats.push({
					id: cat.id,
					value: cat.name.concat(` (${count})`)
				});
			});
		return cats;
	};

	return (
		<SelectElement
			isDefaultOptionDisabled={false}
			isLabelHidden={true}
			id='categoryID'
			icon='ballot'
			iconFam='material-icons'
			label='Elige una categoría'
			parentClass=''
			options={loadCategories()}
			selectClasses='text-sm'
			value={categoryID}
			handleChange={(v) => {
				filterByCategory(v);
			}}
		/>
	);
};
export default FilterByCategory;
